import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 8994C73B-937C-4541-AAFF-6FA2CE0573DF
 * name coffee-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coffee-outline.svg
 * tags
 * - Food / Drink 
 */
export const CoffeeOutlineIcon = createSvgIcon(<><path d="M2,21V19H20V21H2M20,8V5H18V8H20M20,3A2,2 0 0,1 22,5V8A2,2 0 0,1 20,10H18V13A4,4 0 0,1 14,17H8A4,4 0 0,1 4,13V3H20M16,5H6V13A2,2 0 0,0 8,15H14A2,2 0 0,0 16,13V5Z" /></>, 'CoffeeOutlineIcon');
export default CoffeeOutlineIcon